<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__bottom">
        <BackLink />
        <Panel :title="title" variant="attention" />
        <div class="wysiwyg">
            <p v-html="content"></p>
            <p>
                <a href="https://www.nhsggc.scot/hospitals-services/services-a-to-z/musculoskeletal-msk-physiotherapy/" class="btn btn--primary">Return to NHS MSK PHYSIO</a>
            </p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "Endpoint",
  created() {
    this.loadQuestion();
  },
  data() {
    return {
      title: "",
      content: "",
      responses: [],
      userExemptions: {},
      injectionHtml: {},
      checklist: []
    };
  },
  methods: {
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.title = currentQuestion.detailsTitle;
      this.content = currentQuestion.detailsMessage;
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>